import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Capture the install prompt globally so any "App downloaden" button can trigger it
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__vmInstallPrompt = e;
  window.dispatchEvent(new Event("vm-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__vmInstallPrompt = null;
  window.dispatchEvent(new Event("vm-installed"));
});
